/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import styled from 'styled-components';
import {Accordion, AccordionProps} from '@mui/material';

const StyledAccordion = styled(Accordion)`
  border: 1px solid #9fafbc;

  &.Mui-expanded {
    margin: unset;
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: unset;
  }

  & .MuiAccordionSummary-root.Mui-expanded {
    min-height: 48px;
  }

  &:first-of-type {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const BeamAccordion = (props: AccordionProps) => {
  return <StyledAccordion {...props} />;
};
